import React, { Component } from 'react';
import { Economisesc } from '../../svg';
import { isMobile } from '../../util';
import { CTA } from '../../theme';
class Intro extends Component {
    render() {
        return (
            <div id="Intro" className="container__fluid">
                <div className="w__flex w__flex-column Align-center Justify-center">

                    <div className="w__flex w__flex-row Align-center w__switch">
                        <div className="cell switch">
                            {/* <img src={require('../../../assets/img/svg/intrerupator.svg')} alt="Intrerupator" /> */}
                            <Economisesc.Switch />
                        </div>
                    </div>


                    <CTA> {isMobile ? 'Scroll' : 'Mergi din plus in plus'}</CTA>


                </div>
            </div>
        );
    }
}

export default Intro;


// WEBPACK FOOTER //
// ./src/components/pages/Intro/Intro.jsx